<script setup>
defineProps({
  article: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="highlight-article">
    <div class="container">
      <!-- eslint-disable vue/no-v-html -->
      <div class="image-section">
        <nuxt-link
          :to="
            localePath({
              name: 'notizie-slug',
              params: { slug: article.slug },
            })
          "
        >
          <DefaultPicture
            :image="{
              custom: article.landscape.responsiveImage,
            }"
            :lazy-load="true"
            alt="Istituto Canossiano"
          />
        </nuxt-link>
      </div>
      <div class="text-section">
        <div class="in-evidenza"><span>In evidenza</span></div>

        <div class="titolo title-base2 underline-animation">
          <h2>
            <nuxt-link
              :to="
                localePath({
                  name: 'notizie-slug',
                  params: { slug: article.slug },
                })
              "
              ><span v-html="article.titolo"
            /></nuxt-link>
          </h2>
        </div>
        <div class="text-xs-1" v-html="article.intro" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HighlightArticle',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
